import { useEffect, useRef, useState } from "react";
import { useDeepCompareEffectNoCheck } from "use-deep-compare-effect";
import { getMediaDevices } from "./utils/mediaDevices";
export var useMediaDevices = function (_a) {
    var _b = _a === void 0 ? {} : _a, constraints = _b.constraints, _c = _b.onError, onError = _c === void 0 ? function () { } : _c;
    var _d = useState(null), mediaDevices = _d[0], setMediaDevices = _d[1];
    var errorHandlerRef = useRef(null);
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    useEffect(function () {
        errorHandlerRef.current = onError;
    }, [onError]);
    useDeepCompareEffectNoCheck(function () {
        var ac = new AbortController();
        new Promise(function (resolve, reject) {
            ac.signal.addEventListener("abort", reject);
            setLoading(true);
            getMediaDevices(constraints).then(resolve);
        })
            .then(function (devices) {
            setMediaDevices(devices);
        })
            .catch(function (error) {
            var _a;
            if (error.type === "abort")
                return;
            (_a = errorHandlerRef.current) === null || _a === void 0 ? void 0 : _a.call(errorHandlerRef, error);
        })
            .finally(function () {
            setLoading(false);
        });
        return function () {
            ac.abort();
        };
    }, [constraints]);
    return { devices: mediaDevices, loading: loading };
};
